import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  Container as AB,
  Variant,
  Control,
} from '@nerdwallet/nw-client-lib/ab';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Heading, Body } from '@nerdwallet/react-typography';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

import HeroNav from './hero-nav';

import { TILE_LINKS_TEST } from '../../lib/ab-experiment-list';
import {
  heroNavContent,
  experimentalHeroNavContent,
} from '../../lib/front-page-content';

const Hero = ({ content, header, showBackgroundColor }) => (
  <BedrockImpression eventType="element_impression" entityName="hero_container">
    <ElementImpression
      elementDomType="section"
      elementName="Hero"
      id="hero-container"
    >
      <div className="hero-nav">
        <section
          className={classNames(['hero-nav__section', 'ab-variant-spacing'])}
        >
          <div
            className={classNames([
              'hero-nav__content',
              { 'hero-nav__background': showBackgroundColor },
              classes('display-flex'),
              classes('flex-direction-column'),
              classes('justify-content-center'),
              classes('padding-horizontal-4'),
            ])}
          >
            <Heading
              level={1}
              className={classNames([
                'hero-nav__header',
                classes('text-align-center'),
                classes('chronicle-display'),
                classes('margin-bottom-3'),
              ])}
            >
              {header}
            </Heading>
            <Body
              size="large"
              className={classNames([
                'hero-nav__subtitle',
                classes('text-align-center'),
                classes('type-3'),
                classes('margin-horizontal-auto'),
              ])}
            >
              {content}
            </Body>
          </div>
          <AB experimentID={TILE_LINKS_TEST.name}>
            <Control>
              <HeroNav {...heroNavContent} />
            </Control>
            <Variant variantName={TILE_LINKS_TEST.variant}>
              <HeroNav {...experimentalHeroNavContent} />
            </Variant>
          </AB>
        </section>
      </div>
    </ElementImpression>
  </BedrockImpression>
);

Hero.propTypes = {
  content: PropTypes.string,
  header: PropTypes.string,
  showBackgroundColor: PropTypes.bool,
};

Hero.displayName = 'Hero';

export default Hero;
